<template>
  <b-skeleton-wrapper :loading="loading">
    <template #loading>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <b-skeleton animation="wave" width="60%" height="24px" class="mb-4"></b-skeleton>
          <div class="space-y-4">
            <div v-for="i in 5" :key="i" class="flex items-center">
              <b-skeleton animation="wave" width="50%" height="16px"></b-skeleton>
              <b-skeleton animation="wave" width="40%" height="16px" class="ml-2"></b-skeleton>
            </div>
          </div>
        </div>
        <div>
          <b-skeleton animation="wave" width="60%" height="24px" class="mb-4"></b-skeleton>
          <div class="space-y-4">
            <div v-for="i in 5" :key="i" class="flex items-center">
              <b-skeleton animation="wave" width="50%" height="16px"></b-skeleton>
              <b-skeleton animation="wave" width="40%" height="16px" class="ml-2"></b-skeleton>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6"">    

      <div class=" border border-gray-100 rounded-xl p-5 shadow-sm h-full">

        <h3 class="text-lg font-bold text-gray-800 mb-4">Mejores Categorías</h3>
        <div class="space-y-4">
          <div v-for="(item, index) in topSubcategories" :key="index" class="flex items-center">

            <span class="text-sm w-2/3 md:w-1/2 truncate" :title="item.name">
              {{ item.name }}
            </span>

            <div class="relative w-1/3 md:w-1/2 h-4 bg-gray-200 rounded-full overflow-hidden ml-2">
              <div class="absolute left-0 top-0 h-full bg-blue-500 rounded-full" :style="{ width: item.percentage + '%' }">
              </div>
              <span class="absolute right-1 top-1/2 -translate-y-1/2 text-xs font-semibold text-blue-800">
                {{ item.precision }}%
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="border border-gray-100 rounded-xl p-5 shadow-sm h-full">
        <h3 class="text-lg font-bold text-gray-800 mb-4">Áreas a Reforzar</h3>
        <div class="space-y-4">
          <div v-for="(item, index) in worstsubategories" :key="index" class="flex items-center">

            <span class="text-sm w-2/3 md:w-1/2 truncate" :title="item.name">
              {{ item.name }}
            </span>

            <div class="relative w-1/3 md:w-1/2 h-4 bg-gray-200 rounded-full overflow-hidden ml-2">
              <div class="absolute left-0 top-0 h-full bg-red-500 rounded-full" :style="{ width: item.precision + '%' }">
              </div>
              <span class="absolute right-1 top-1/2 -translate-y-1/2 text-xs font-semibold text-red-800">
                {{ item.precision }}%
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-skeleton-wrapper>
</template>

<script>
import { getWorstAndBest } from '@/services/CourseStats.service';

export default {
  name: 'WorstAndBest',

  data() {
    return {
      loading: true,
      topSubcategories: [], // { name: 'Ecuaciones e Inecuaciones', precision: 91 },
      worstsubategories: [] // { name: 'Operaciones básicas', precision: 41 },
    };
  },

  props: {
    courseId: {
      type: Number,
      required: true,
      default: 0
    },
    isPremium: {
      type: Boolean,
      default: true
    }
  },

  watch: {
    courseId(newValue) {
      // No cargar datos si no es premium
      if (!this.isPremium) {
        return;
      }
      this.fetchData(newValue)
    },
    isPremium(newValue) {
      // Si el usuario se vuelve premium, cargar los datos
      if (newValue && this.courseId) {
        this.loading = true;
        this.fetchData(this.courseId);
      }
    }
  },

  created() {
    // Si no es premium, mantener loading indefinidamente y no cargar datos
    if (!this.isPremium) {
      this.loading = true;
      return;
    }

    this.fetchData(this.courseId);
  },

  mounted() {
    // Si no es premium, mantener skeleton indefinidamente
    if (!this.isPremium) {
      this.loading = true;
    }
  },

  methods: {
    async fetchData(courseId) {
      if (!courseId || !this.isPremium) return;

      try {
        const response = await getWorstAndBest(courseId);

        this.topSubcategories = response.best?.map(cat => ({
          name: cat.key,
          precision: cat.accuracy.toFixed(2) * 100
        }))

        this.worstsubategories = response.worst?.map(cat => ({
          name: cat.key,
          precision: cat.accuracy.toFixed(2) * 100
        }));
        this.loading = false; // Ocultar skeleton inmediatamente después de cargar
      } catch (error) {
        console.error("Error fetching best and worst subcategories:", error);
        this.loading = false; // Ocultar skeleton incluso si hay error
      }
    },
  },
}
</script>